// Why a sign-in did not finish — the closed set, and the sentence for each.
//
// The Function emits only a CODE, in `/signed-out?reason=<code>`; the page
// renders the sentence. Two reasons for the split, both of which have bitten
// somebody somewhere:
//
//   * A message passed through a URL is a message an attacker can choose. A
//     closed set with a fallback means `?reason=<anything else>` renders the
//     generic sentence and never the attacker's text.
//   * The refusal wording is a design decision, and it belongs next to the
//     other design decisions rather than inside a redirect.
//
// Register: "Plain language where it matters — errors, refusals... The bot's
// personality lives in flavour text and embeds, never in an error message."
// Nothing here is funny, nothing apologises, and NOT-A-MEMBER does not imply
// the reader did something wrong.

export const REASON = {
  NOT_A_MEMBER: 'not-a-member',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
}

export const REASON_TEXT = {
  [REASON.NOT_A_MEMBER]: {
    heading: 'Not in the server',
    body:
      'You signed in with Discord, but that account is not a member of the D A Y 2 D A Y ' +
      'server. These pages are only for people in it. If you think that is wrong, ask ' +
      'someone in the server — nothing here can let you in.',
  },
  [REASON.EXPIRED]: {
    heading: 'That sign-in expired',
    body:
      'The sign-in took too long, or it was started somewhere else. Nothing went wrong ' +
      'with your account. Start again.',
  },
  [REASON.CANCELLED]: {
    heading: 'Sign-in cancelled',
    body: 'Discord did not hand anything over, so you are not signed in.',
  },
}

/** The sentence for a code, or the generic one. Never renders the raw value. */
export function reasonText(code) {
  return (
    REASON_TEXT[code] ?? {
      heading: 'Not signed in',
      body: 'The sign-in did not finish. Nothing about your account changed.',
    }
  )
}
